module.exports = __webpack_public_path__ + "img/add.d9b5f325.svg";